<template>
  <div>
    <slot>
        <TheHeader />
    </slot>
    <div class="componata-container" v-if="confirmed">
      <h1>Selfservice zum Hinterlegen von Bestelldaten</h1>
      <FlashMessage type="info">
        <p>Ihre Daten wurden übermittelt. Die Übermittlung sollte Ihnen innderhalb der nächsten Minuten per Mail bestätigt werden. Sollten Sie Fragen haben, wenden Sie sich gern an unseren Kundenservice: <a href="mailto:kundenservice@componata.de">kundenservice@componata.de</a></p>
      </FlashMessage>
    </div>
    <div class="componata-container" v-if="!confirmed">
        <slot>
            <h1>Selfservice zum Hinterlegen von Bestelldaten</h1>
            <slot v-if="done">
              <FlashMessage type="error">
               <p>Für die angegebene Bestellung wurden bereits Daten hinterlegt. Sollten Sie Änderungswünsche oder Fragen haben, wenden Sie sich gern an unseren Kundenservice: <a href="mailto:kundenservice@componata.de">kundenservice@componata.de</a></p>
              </FlashMessage>
            </slot>
            <slot v-if="isLoaded">
              <div class="content">
              <p>Bitte beachten Sie, dass Sie die Daten nur einmalig eintragen können. Mit "Abschicken" übermitteln Sie uns die Daten verbindlich.</p>
              <p>Sie haben folgende Einstellungen gewählt: </p>
              </div>
              <h2>Grußkarte</h2>
              <div class="content">
              {{ getPostcardMainModeString(composerData.postcard.main.mode) }}, {{ getPostcardMotiveModeString(composerData.postcard.motive.mode) }}:<br />
              <img class="previewImage" v-if="composerData.postcard.motive.mode = 1" :src="composerData.postcard.motive.card.src"/><br />
              {{ getMessageModeString(composerData.postcard.message.mode) }}, {{ getMessageOptionString(composerData.postcard.message.option) }}
              <p class="text-box" v-if="composerData.postcard.message.mode<3 && composerData.postcard.message.option==1"><b>Ihr Text: </b>{{ composerData.postcard.message.text }}</p>
              </div>
                <h2>Versand ({{ getShippingString(composerData.shipping) }})</h2>
                <div class="content">
                  <div v-if="composerData.shipping.main.mode == 3 || composerData.shipping.main.mode == 5">
                  <h3>Absenderadresse</h3>
                  <p>Um eine hohe Annahmequote der Pakete zu erreichen, geben wir grundsätzlich Sie als Kunden als Absender der Präsente an. Beim Absender "Componata" nehmen unverhältnismäßig viele Empfänger:innen die jeweilige Sendung nicht an ("ich habe doch nichts bestellt") - mit der Kundenadresse als Absender lässt sich die Sendung für den Beschenkten direkt zuordnen.</p>
                    <div class="grid">
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>Absender Name 1</label>
                        <input
                          type="text"
                          name="Absender Name 1"
                          :id="invoiceAddress+'#name1'"
                          v-model="invoiceAddress['name1']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>Absender Name 2</label>
                        <input
                          type="text"
                          :id="invoiceAddress+'#name2'"
                          v-model="invoiceAddress['name2']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>Absenderadresse</label>
                        <input
                          type="text"
                          :id="invoiceAddress+'#street'"
                          v-model="invoiceAddress['street']"
                          class="form-control"
                        />
                    </div>
                    </div>
                    <div class="col-1">
                      <div class="form__group">
                        <label>Haunummer</label>
                        <input
                          type="text"
                          :id="invoiceAddress+'#hn'"
                          v-model="invoiceAddress['hn']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-1">
                      <div class="form__group">
                        <label>PLZ</label>
                        <input
                          type="text"
                          :id="invoiceAddress+'#zip'"
                          v-model="invoiceAddress['zip']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>Ort</label>
                        <input
                          type="text"
                          :id="invoiceAddress+'#city'"
                          v-model="invoiceAddress['city']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>Land</label>
                        <select
                          :id="invoiceAddress+'#country'"
                          v-model="invoiceAddress['country']"
                          class="form-control"
                        >
                        <option v-for="option in countries" :value="option.value" :key="option.value">
                          {{ option.text }}
                        </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>Mail</label>
                        <input
                          type="text"
                          :id="invoiceAddress+'#mail'"
                          v-model="invoiceAddress['mail']"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
              <div v-if="composerData.shipping.main.mode == 3 || composerData.shipping.main.mode == 4 || composerData.shipping.main.mode == 5">
                <div v-for="address in addresses" :key="address.index" class="content">
                  <h3>Empfängeradressen</h3>
                  <div class="grid">
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>Empfänger Name 1</label>
                        <input
                          @focusout="validate"
                          type="text"
                          name="Empfänger Name 1"
                          :id="address['index']+'#name1'"
                          v-model="address['name1']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>Empfänger Name 2</label>
                        <input
                          type="text"
                          :id="address['index']+'#name2'"
                          v-model="address['name2']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>Empfänger Name 3</label>
                        <input
                          type="text"
                          :id="address['index']+'#name3'"
                          v-model="address['name3']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>Straße</label>
                        <input
                          @focusout="validate"
                          type="text"
                          :id="address['index']+'#street'"
                          v-model="address['street']"
                          class="form-control"
                        />
                    </div>
                    </div>
                    <div class="col-1">
                      <div class="form__group">
                        <label>Haunummer</label>
                        <input
                          @focusout="validate"
                          type="text"
                          :id="address['index']+'#hn'"
                          v-model="address['hn']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-1">
                      <div class="form__group">
                        <label>PLZ</label>
                        <input
                          @focusout="validate"
                          type="text"
                          :id="address['index']+'#zip'"
                          v-model="address['zip']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>Ort</label>
                        <input
                          @focusout="validate"
                          type="text"
                          :id="address['index']+'#city'"
                          v-model="address['city']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>Land</label>
                        <select
                          @focusout="validate"
                          :id="address['index']+'#country'"
                          v-model="address['country']"
                          class="form-control"
                        >
                        <option v-for="option in countries" :value="option.value" :key="option.value">
                          {{ option.text }}
                        </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-2_lg-3_xs-6">
                      <div class="form__group">
                        <label>Mail</label>
                        <input
                          type="text"
                          :id="address['index']+'#mail'"
                          v-model="address['mail']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div v-if="composerData.shipping.main.mode == 4 || composerData.shipping.main.mode == 5" class="col-1_lg-3_xs-6">
                      <div class="form__group">
                        <label>Anzahl</label>
                        <input
                          disabled
                          type="number"
                          :id="address['index']+'#qty'"
                          v-model="address['qty']"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div v-if="composerData.postcard.main.mode == 1 && composerData.postcard.message.mode == 1 && composerData.postcard.message.option != 1 && composerData.shipping.main.mode != 4" class="col-6">
                      <div class="form__group">
                        <label>Grußkartentext ({{ address['card']['text'].length }} Zeichen {{ extraFee(address['card']['text'].length) }})</label>
                        <textarea
                          class="form-control"
                          :id="address['index']+'#text'"
                          v-model="address['card']['text']"
                          v-on:input="check(false, address.index)"
                          />
                      </div>
                    </div>
                      <div v-for="index in address['qty']" :key="index" class="col-4">
                        <div v-if="composerData.postcard.main.mode == 1 && composerData.postcard.message.mode == 1 && composerData.postcard.message.option != 1 && composerData.shipping.main.mode == 4">
                        <div class="form__group">
                          <label>Grußkartentext Empfänger {{ index }} ({{ address.persons[index-1]['text'].length }} Zeichen {{ extraFee(address.persons[index-1]['text'].length) }})</label>
                          <textarea
                            class="form-control"
                            :id="address['index']+'#text'"
                            v-model="address['persons'][index-1]['text']"
                            v-on:input="check(true, {address: address.index, person: index})"
                            />
                        </div>
                      </div>
                  </div>
                  </div>
                  <slot>
                    <FlashMessage v-if="address.missing.length > 0" type="warning">
                      <p>Folgende Einträge sind Pflicht:</p>
                      <ul>
                        <li class="missing-info" v-for="missing in address.missing" :key="missing">
                          {{ getAddressFieldString(missing) }}
                        </li>
                      </ul>
                    </FlashMessage>
                  </slot>
                </div>
              </div>
              <div class="content">
                <h3>Versandzeitpunkt</h3>
                <p>Frühenstens ab {{ getDateString(composerDelTime) }} möglich.</p>
                <FlashMessage type="info">
                  <p>Wir bemühen uns stets um punktgenauen Versand. Bitte haben Sie Verständnis dafür, dass der Versand aus prozesstechnischen Gründen maximal zwei Werktage vor bzw. nach dem angegebenen Datum erfolgen kann.</p>
                </FlashMessage>
                <input type="date" v-model="selectedDate" :min="getIsoDate(composerDelTime)" />
              </div>
              <input
                    type="button"
                    value="Abschicken"
                    @click="submit"
                    />
            </slot>
        </slot>
    </div>
    </div>
</template>

<script>
import TheHeader from '@/components/TheHeader';
import { logicMixin } from '@/mixins/LogicMixin';
import { LoaderMixin } from '@/mixins/LoaderMixin';
import Vue from 'vue';
import axios from 'axios';
import FlashMessage from '@/components/Composer/FlashMessage';
Vue.component('modal', {
  template: '#modal-template'
});
export default {
  name: 'Selfservice',
  mixins: [logicMixin, LoaderMixin],
  components: {
    TheHeader,
    FlashMessage
  },
  data () {
    return {
      isLoaded: false,
      showModal: false,
      confirmed: false,
      customerName: '',
      customerMail: '',
      composerData: {},
      quantity: 0,
      box: '',
      weight: '',
      composerDelTime: '',
      selectedDate: new Date(),
      addresses: [],
      invoiceAddress: {},
      shippingAddress: {},
      orderId: '',
      boxKey: '',
      done: false,
      required: ['name1', 'street', 'hn', 'zip', 'city', 'country'],
      countries: [
        { value: 'AF', text: 'Afghanistan' },
        { value: 'EG', text: 'Ägypten' },
        { value: 'AL', text: 'Albanien' },
        { value: 'DZ', text: 'Algerien' },
        { value: 'AD', text: 'Andorra' },
        { value: 'AO', text: 'Angola' },
        { value: 'AI', text: 'Anguilla' },
        { value: 'AQ', text: 'Antarktis' },
        { value: 'AG', text: 'Antigua und Barbuda' },
        { value: 'GQ', text: 'Äquatorial Guinea' },
        { value: 'AR', text: 'Argentinien' },
        { value: 'AM', text: 'Armenien' },
        { value: 'AW', text: 'Aruba' },
        { value: 'AZ', text: 'Aserbaidschan' },
        { value: 'ET', text: 'Äthiopien' },
        { value: 'AU', text: 'Australien' },
        { value: 'BS', text: 'Bahamas' },
        { value: 'BH', text: 'Bahrain' },
        { value: 'BD', text: 'Bangladesh' },
        { value: 'BB', text: 'Barbados' },
        { value: 'BE', text: 'Belgien' },
        { value: 'BZ', text: 'Belize' },
        { value: 'BJ', text: 'Benin' },
        { value: 'BM', text: 'Bermudas' },
        { value: 'BT', text: 'Bhutan' },
        { value: 'MM', text: 'Birma' },
        { value: 'BO', text: 'Bolivien' },
        { value: 'BA', text: 'Bosnien-Herzegowina' },
        { value: 'BW', text: 'Botswana' },
        { value: 'BV', text: 'Bouvet Inseln' },
        { value: 'BR', text: 'Brasilien' },
        { value: 'IO', text: 'Britisch-Indischer Ozean' },
        { value: 'BN', text: 'Brunei' },
        { value: 'BG', text: 'Bulgarien' },
        { value: 'BF', text: 'Burkina Faso' },
        { value: 'BI', text: 'Burundi' },
        { value: 'CL', text: 'Chile' },
        { value: 'CN', text: 'China' },
        { value: 'CX', text: 'Christmas Island' },
        { value: 'CK', text: 'Cook Inseln' },
        { value: 'CR', text: 'Costa Rica' },
        { value: 'DK', text: 'Dänemark' },
        { value: 'DE', text: 'Deutschland' },
        { value: 'DJ', text: 'Djibuti' },
        { value: 'DM', text: 'Dominika' },
        { value: 'DO', text: 'Dominikanische Republik' },
        { value: 'EC', text: 'Ecuador' },
        { value: 'SV', text: 'El Salvador' },
        { value: 'CI', text: 'Elfenbeinküste' },
        { value: 'ER', text: 'Eritrea' },
        { value: 'EE', text: 'Estland' },
        { value: 'FK', text: 'Falkland Inseln' },
        { value: 'FO', text: 'Färöer Inseln' },
        { value: 'FJ', text: 'Fidschi' },
        { value: 'FI', text: 'Finnland' },
        { value: 'FR', text: 'Frankreich' },
        { value: 'GF', text: 'französisch Guyana' },
        { value: 'PF', text: 'Französisch Polynesien' },
        { value: 'TF', text: 'Französisches Süd-Territorium' },
        { value: 'GA', text: 'Gabun' },
        { value: 'GM', text: 'Gambia' },
        { value: 'GE', text: 'Georgien' },
        { value: 'GH', text: 'Ghana' },
        { value: 'GI', text: 'Gibraltar' },
        { value: 'GD', text: 'Grenada' },
        { value: 'GR', text: 'Griechenland' },
        { value: 'GL', text: 'Grönland' },
        { value: 'GB', text: 'Großbritannien (UK)' },
        { value: 'GP', text: 'Guadeloupe' },
        { value: 'GU', text: 'Guam' },
        { value: 'GT', text: 'Guatemala' },
        { value: 'GN', text: 'Guinea' },
        { value: 'GW', text: 'Guinea Bissau' },
        { value: 'GY', text: 'Guyana' },
        { value: 'HT', text: 'Haiti' },
        { value: 'HM', text: 'Heard und McDonald Islands' },
        { value: 'HN', text: 'Honduras' },
        { value: 'HK', text: 'Hong Kong' },
        { value: 'IN', text: 'Indien' },
        { value: 'ID', text: 'Indonesien' },
        { value: 'IQ', text: 'Irak' },
        { value: 'IR', text: 'Iran' },
        { value: 'IE', text: 'Irland' },
        { value: 'IS', text: 'Island' },
        { value: 'IL', text: 'Israel' },
        { value: 'IT', text: 'Italien' },
        { value: 'JM', text: 'Jamaika' },
        { value: 'JP', text: 'Japan' },
        { value: 'YE', text: 'Jemen' },
        { value: 'JO', text: 'Jordanien' },
        { value: 'YU', text: 'Jugoslawien' },
        { value: 'KY', text: 'Kaiman Inseln' },
        { value: 'KH', text: 'Kambodscha' },
        { value: 'CM', text: 'Kamerun' },
        { value: 'CA', text: 'Kanada' },
        { value: 'CV', text: 'Kap Verde' },
        { value: 'KZ', text: 'Kasachstan' },
        { value: 'KE', text: 'Kenia' },
        { value: 'KG', text: 'Kirgisistan' },
        { value: 'KI', text: 'Kiribati' },
        { value: 'CC', text: 'Kokosinseln' },
        { value: 'CO', text: 'Kolumbien' },
        { value: 'KM', text: 'Komoren' },
        { value: 'CG', text: 'Kongo' },
        { value: 'CD', text: 'Kongo, Demokratische Republik' },
        { value: 'HR', text: 'Kroatien' },
        { value: 'CU', text: 'Kuba' },
        { value: 'KW', text: 'Kuwait' },
        { value: 'LA', text: 'Laos' },
        { value: 'LS', text: 'Lesotho' },
        { value: 'LV', text: 'Lettland' },
        { value: 'LB', text: 'Libanon' },
        { value: 'LR', text: 'Liberia' },
        { value: 'LY', text: 'Libyen' },
        { value: 'LI', text: 'Liechtenstein' },
        { value: 'LT', text: 'Litauen' },
        { value: 'LU', text: 'Luxemburg' },
        { value: 'MO', text: 'Macao' },
        { value: 'MG', text: 'Madagaskar' },
        { value: 'MW', text: 'Malawi' },
        { value: 'MY', text: 'Malaysia' },
        { value: 'MV', text: 'Malediven' },
        { value: 'ML', text: 'Mali' },
        { value: 'MT', text: 'Malta' },
        { value: 'MP', text: 'Marianen' },
        { value: 'MA', text: 'Marokko' },
        { value: 'MH', text: 'Marshall Inseln' },
        { value: 'MQ', text: 'Martinique' },
        { value: 'MR', text: 'Mauretanien' },
        { value: 'MU', text: 'Mauritius' },
        { value: 'YT', text: 'Mayotte' },
        { value: 'MK', text: 'Mazedonien' },
        { value: 'MX', text: 'Mexiko' },
        { value: 'FM', text: 'Mikronesien' },
        { value: 'MZ', text: 'Mocambique' },
        { value: 'MD', text: 'Moldavien' },
        { value: 'MC', text: 'Monaco' },
        { value: 'MN', text: 'Mongolei' },
        { value: 'MS', text: 'Montserrat' },
        { value: 'NA', text: 'Namibia' },
        { value: 'NR', text: 'Nauru' },
        { value: 'NP', text: 'Nepal' },
        { value: 'NC', text: 'Neukaledonien' },
        { value: 'NZ', text: 'Neuseeland' },
        { value: 'NI', text: 'Nicaragua' },
        { value: 'NL', text: 'Niederlande' },
        { value: 'AN', text: 'Niederländische Antillen' },
        { value: 'NE', text: 'Niger' },
        { value: 'NG', text: 'Nigeria' },
        { value: 'NU', text: 'Niue' },
        { value: 'KP', text: 'Nord Korea' },
        { value: 'NF', text: 'Norfolk Inseln' },
        { value: 'NO', text: 'Norwegen' },
        { value: 'OM', text: 'Oman' },
        { value: 'AT', text: 'Österreich' },
        { value: 'PK', text: 'Pakistan' },
        { value: 'PS', text: 'Palästina' },
        { value: 'PW', text: 'Palau' },
        { value: 'PA', text: 'Panama' },
        { value: 'PG', text: 'Papua Neuguinea' },
        { value: 'PY', text: 'Paraguay' },
        { value: 'PE', text: 'Peru' },
        { value: 'PH', text: 'Philippinen' },
        { value: 'PN', text: 'Pitcairn' },
        { value: 'PL', text: 'Polen' },
        { value: 'PT', text: 'Portugal' },
        { value: 'PR', text: 'Puerto Rico' },
        { value: 'QA', text: 'Qatar' },
        { value: 'RE', text: 'Reunion' },
        { value: 'RW', text: 'Ruanda' },
        { value: 'RO', text: 'Rumänien' },
        { value: 'RU', text: 'Russland' },
        { value: 'LC', text: 'Saint Lucia' },
        { value: 'ZM', text: 'Sambia' },
        { value: 'AS', text: 'Samoa' },
        { value: 'WS', text: 'Samoa' },
        { value: 'SM', text: 'San Marino' },
        { value: 'ST', text: 'Sao Tome' },
        { value: 'SA', text: 'Saudi Arabien' },
        { value: 'SE', text: 'Schweden' },
        { value: 'CH', text: 'Schweiz' },
        { value: 'SN', text: 'Senegal' },
        { value: 'SC', text: 'Seychellen' },
        { value: 'SL', text: 'Sierra Leone' },
        { value: 'SG', text: 'Singapur' },
        { value: 'SK', text: 'Slowakei' },
        { value: 'SI', text: 'Slowenien' },
        { value: 'SB', text: 'Solomon Inseln' },
        { value: 'SO', text: 'Somalia' },
        { value: 'GS', text: 'South Georgia, South Sandwich Isl.' },
        { value: 'ES', text: 'Spanien' },
        { value: 'LK', text: 'Sri Lanka' },
        { value: 'SH', text: 'St. Helena' },
        { value: 'KN', text: 'St. Kitts Nevis Anguilla' },
        { value: 'PM', text: 'St. Pierre und Miquelon' },
        { value: 'VC', text: 'St. Vincent' },
        { value: 'KR', text: 'Süd Korea' },
        { value: 'ZA', text: 'Südafrika' },
        { value: 'SD', text: 'Sudan' },
        { value: 'SR', text: 'Surinam' },
        { value: 'SJ', text: 'Svalbard und Jan Mayen Islands' },
        { value: 'SZ', text: 'Swasiland' },
        { value: 'SY', text: 'Syrien' },
        { value: 'TJ', text: 'Tadschikistan' },
        { value: 'TW', text: 'Taiwan' },
        { value: 'TZ', text: 'Tansania' },
        { value: 'TH', text: 'Thailand' },
        { value: 'TP', text: 'Timor' },
        { value: 'TG', text: 'Togo' },
        { value: 'TK', text: 'Tokelau' },
        { value: 'TO', text: 'Tonga' },
        { value: 'TT', text: 'Trinidad Tobago' },
        { value: 'TD', text: 'Tschad' },
        { value: 'CZ', text: 'Tschechische Republik' },
        { value: 'TN', text: 'Tunesien' },
        { value: 'TR', text: 'Türkei' },
        { value: 'TM', text: 'Turkmenistan' },
        { value: 'TC', text: 'Turks und Kaikos Inseln' },
        { value: 'TV', text: 'Tuvalu' },
        { value: 'UG', text: 'Uganda' },
        { value: 'UA', text: 'Ukraine' },
        { value: 'HU', text: 'Ungarn' },
        { value: 'UY', text: 'Uruguay' },
        { value: 'UZ', text: 'Usbekistan' },
        { value: 'VU', text: 'Vanuatu' },
        { value: 'VA', text: 'Vatikan' },
        { value: 'VE', text: 'Venezuela' },
        { value: 'AE', text: 'Vereinigte Arabische Emirate' },
        { value: 'US', text: 'Vereinigte Staaten von Amerika' },
        { value: 'VN', text: 'Vietnam' },
        { value: 'VG', text: 'Virgin Island (Brit.)' },
        { value: 'VI', text: 'Virgin Island (USA)' },
        { value: 'WF', text: 'Wallis et Futuna' },
        { value: 'BY', text: 'Weissrussland' },
        { value: 'EH', text: 'Westsahara' },
        { value: 'CF', text: 'Zentralafrikanische Republik' },
        { value: 'ZW', text: 'Zimbabwe' },
        { value: 'CY', text: 'Zypern' }
      ]
    };
  },
  methods: {
    init () {
    },
    check(multi, id) {
      if (!multi) {
        this.addresses[id].card.text = this.addresses[id].card.text.substr(0, 480);
        if (this.addresses[id].card.text.length >= 480) {
          alert('Bitte beachten Sie das Limit von 480 Zeichen.');
        }
      } else {
        this.addresses[id.address].persons[id.person - 1].text = this.addresses[id.address].persons[id.person - 1].text.substr(0, 480);
        if (this.addresses[id.address].persons[id.person - 1].text.length >= 480) {
          alert('Bitte beachten Sie das Limit von 480 Zeichen.');
        }
      }
    },
    submit() {
      var validation = true;
      this.addresses.forEach(element => {
        if (element.missing.length !== 0) {
          validation = false;
        }
      });
      if (validation) {
        this.addresses.forEach(element => {
          delete element.missing;
          delete element.index;
        });
        var ret = {
          receiverAddresses: this.addresses,
          shippingDate: this.selectedDate,
          shipperAddress: this.invoiceAddress,
          wcOrderId: this.$route.params.orderId,
          boxKey: this.boxKey,
          customerMail: this.customerMail,
          customerName: this.customerName
        };
        axios.post('https://api.componata.de/setSelfServiceData', JSON.stringify(ret)).then(function (response) {
        });
        axios
          .get(process.env.VUE_APP_BASE_URL + '/wp-json/geschenkbox/v1/set_selfservice_confirmation/' + this.$route.params.orderId + '?order_id=' + this.orderId + '&box_key=' + this.boxKey)
          .then((confirmationData) => {
            if (confirmationData.data.success) {
              this.confirmed = true;
            }
          });
      } else {
        alert('Bitte vervollständigen Sie ihre Angaben');
      }
    },
    getShippingString(composerShippingOption) {
      switch (composerShippingOption.main.mode) {
        case 1:
          return 'Direktversand an Beschenkte';
        case 2:
          return 'Versand an Sie';
        case 3:
          return 'Direktversand an Beschenkte';
        case 4:
          return 'Sammelversand';
        case 5:
          return 'Kombiversand';
        case 6:
          return 'Später festlegen';
      }
    },
    getPostcardMainModeString(postcardMainModeString) {
      switch (postcardMainModeString) {
        case 1:
          return 'Mit Grußkarte';
        case 2:
          return 'Externe Grußkarte';
        case 3:
          return 'Ohne Grußkarte';
        case 4:
          return 'Später festlegen';
      }
    },
    getPostcardMotiveModeString(postcardMotiveModeString) {
      switch (postcardMotiveModeString) {
        case 1:
          return 'Componata Motiv';
        case 2:
          return 'Eigenes Motiv (Kunde)';
      }
    },
    getMessageModeString(messageModeString) {
      switch (messageModeString) {
        case 1:
          return 'Handgeschrieben';
        case 2:
          return 'Gedruckt';
        case 3:
          return 'Ohne Text';
        case 4:
          return 'Später festlegen';
      }
    },
    getMessageOptionString(messagOptionString) {
      switch (messagOptionString) {
        case 1:
          return 'Gleicher Text für alle Präsente';
        case 2:
          return 'Gleicher Text + persönliche Anrede';
        case 3:
          return 'Unterschiedliche Texte';
      }
    },
    getAddressFieldString(id) {
      switch (id) {
        case 'name1':
          return 'Empfänger Name 1';
        case 'name2':
          return 'Empfänger Name 2';
        case 'name3':
          return 'Empfänger Name 3';
        case 'street':
          return 'Straße';
        case 'hn':
          return 'Hausnummer';
        case 'zip':
          return 'Postleitzahl';
        case 'city':
          return 'Ort';
        case 'country':
          return 'Land';
      }
    },
    validate (e) {
      const id = e.target.id.split('#')[0];
      this.addressValidation(id);
    },
    addressValidation (id) {
      const address = this.addresses[id];
      var tempMissing = [];
      this.required.forEach(element => {
        if (!(element in address)) {
          tempMissing.push(element);
        } else if (address[element] === '') {
          tempMissing.push(element);
        }
      });
      this.addresses[id].missing = tempMissing;
    },
    loadShippingToAddressOne () {
      if (this.shippingAddress.company.length > 0) {
        this.addresses[0].name1 = this.shippingAddress.company;
        this.addresses[0].name2 = this.shippingAddress.first_name + ' ' + this.shippingAddress.last_name;
        this.addresses[0].name3 = this.shippingAddress.address_2;
      } else {
        this.addresses[0].name1 = this.shippingAddress.first_name + ' ' + this.shippingAddress.last_name;
        this.addresses[0].name2 = this.shippingAddress.address_2;
      }
      if (this.shippingAddress.address_1.split(' ').length > 1) {
        var len = this.shippingAddress.address_1.split(' ').length;
        var i = 0;
        this.shippingAddress.address_1.split(' ').forEach(element => {
          i += 1;
          if (i < len) {
            this.addresses[0].street += element + ' ';
          } else {
            this.addresses[0].hn = element;
          }
        });
      } else {
        this.addresses[0].street = this.shippingAddress.address_1;
      }
      this.addresses[0].street = this.addresses[0].street.trim().replace('undefined', '');
      this.addresses[0].zip = this.shippingAddress.postcode;
      this.addresses[0].city = this.shippingAddress.city;
      this.addresses[0].country = this.shippingAddress.country;
      this.addresses[0].mail = this.invoiceAddress.email;
      this.addressValidation(0);
    },
    convertWPInvoiceAddress(address) {
      this.customerName = address.first_name + ' ' + address.last_name;
      this.customerMail = address.email;
      if (address.company.length > 0) {
        this.invoiceAddress.name1 = address.company;
      } else {
        this.invoiceAddress.name1 = address.first_name + ' ' + address.last_name;
      }
      if (address.address_1.split(' ').length > 1) {
        var len = address.address_1.split(' ').length;
        var i = 0;
        address.address_1.split(' ').forEach(element => {
          i += 1;
          if (i < len) {
            this.invoiceAddress.street += element + ' ';
          } else {
            this.invoiceAddress.hn = element;
          }
        });
      } else {
        this.invoiceAddress.street = address.address_1;
      }
      this.invoiceAddress.name2 = '';
      this.invoiceAddress.name3 = '';
      this.invoiceAddress.name2 = '';
      this.invoiceAddress.shipperPhone = '';
      this.invoiceAddress.shipFromAttention = 'Gift';
      this.invoiceAddress.street = this.invoiceAddress.street.trim().replace('undefined', '');
      this.invoiceAddress.zip = address.postcode;
      this.invoiceAddress.city = address.city;
      this.invoiceAddress.country = address.country;
      this.invoiceAddress.mail = address.email;
    },
    calcShippingDate() {
      if (this.composerDelTime.toLowerCase().includes('sofort versandfertig')) {
        this.composerDelTime = this.addDays(new Date(), 1);
      } else if (this.composerDelTime.toLowerCase().includes('morgen versandfertig')) {
        this.composerDelTime = this.addDays(new Date(), 2);
      } else if (this.composerDelTime.toLowerCase().includes('tagen versandfertig')) {
        this.composerDelTime = this.addDays(new Date(), parseInt(this.composerDelTime.split(' ')[1]) + 1);
      } else if (this.composerDelTime.toLowerCase().includes('versandfertig')) {
        const myParsed = this.composerDelTime
          .split(' ')[2]
          .split('.')
          .reverse()
          .join('-');
        this.composerDelTime = new Date(`20${myParsed}`);
      }
    },
    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      if (result.getDay() === 6) {
        result = this.addDays(result, 2);
      } else if (result.getDay() === 0) {
        result = this.addDays(result, 1);
      }
      return result;
    },
    getIsoDate(date) {
      return date.toISOString().slice(0, 10);
    },
    getDateString(date) {
      return ('0' + date.getDate()).slice(-2) + '.' + ('0' + String(parseInt(date.getMonth()) + 1)).slice(-2) + '.' + date.getFullYear();
    },
    extraFee(length) {
      if (length < 160) {
        return '';
      } else if (length < 320) {
        return '2,00€ zzgl. MwSt extra Grußkartentext über 160 Zeichen';
      } else {
        return '4,00€ zzgl. MwSt extra für Grußkartentext über 320 Zeichen - Maximal 480 Zeichen möglich!';
      }
    }
  },
  created () {
    this.init();
    this.boxKey = this.$route.query.box_key;
    this.orderId = this.$route.query.order_id;
    axios
      .get(process.env.VUE_APP_BASE_URL + '/wp-json/geschenkbox/v1/get_composerstring_order/' + this.$route.params.orderId + '?order_id=' + this.orderId + '&box_key=' + this.boxKey)
      .then((selfserviceRes) => {
        if (selfserviceRes.data) {
          if (selfserviceRes.data.done) {
            this.done = true;
          } else {
            this.composerData = JSON.parse(selfserviceRes.data.composer.replace('\\', ''));
            var addressAmount = 0;
            var qty = 1;
            this.convertWPInvoiceAddress(selfserviceRes.data.invoice);
            this.composerDelTime = selfserviceRes.data.del_time.replace('am', ' ');
            this.calcShippingDate();
            this.selectedDate = this.getIsoDate(this.composerDelTime);
            var persons = [];
            this.quantity = selfserviceRes.data.qty;
            if (this.composerData.shipping.main.mode === 3 || this.composerData.shipping.main.mode === 5) {
              addressAmount = selfserviceRes.data.qty;
            } else if (this.composerData.shipping.main.mode === 4 && this.composerData.shipping.bulk.multipleLocations === false) {
              addressAmount = 1;
              this.shippingAddress = selfserviceRes.data.shipping;
              qty = selfserviceRes.data.qty;
              for (let i = 0; i <= qty; i++) {
                persons.push({
                  name: 'Name',
                  text: ''
                });
              }
            }
            for (let index = 0; index < addressAmount; index++) {
              this.addresses.push({
                index: index,
                name1: '',
                name2: '',
                name3: '',
                street: '',
                hn: '',
                zip: '',
                city: '',
                qty: qty,
                missing: this.required,
                persons: persons,
                country: 'DE',
                reference: '$JTLORDERNR$-' + index,
                card: {
                  card: null,
                  text: ''
                }
              });
            }
            if (this.composerData.shipping.main.mode === 4 && this.composerData.shipping.bulk.multipleLocations === false) {
              this.loadShippingToAddressOne();
            }
            this.isLoaded = true;
          }
        }
      });
  }

};

</script>

<style scoped>

.previewImage {
  max-width: 20%;
}
.text-box {
  background-color: aliceblue;
  font-style: italic;
}
.content {
  box-shadow: 0 0.5em 1em -0.125em rgba(10, 10, 10, 0.1), 0 0px 0 1px rgba(10, 10, 10, 0.02);
  padding: 5px;
  margin-bottom: 5px;
}

.form-control {
  border-radius: 0.25rem;
  border: 1px solid #c4cdd5;
  box-shadow: inset 0 1px 2px 0 rgba(99,115,129,.2);
  width: 100%;
}

</style>
